module.exports = __webpack_public_path__ + "static/media/improve.995b06da.png";